import { I18n } from '@calendly/i18n'
import { SimplePopup } from '@calendly/ui/components/popup'

export const DisablePopup = ({ isOpen, onClose, onDisable }) => (
  <SimplePopup
    isOpen={isOpen}
    onClose={onClose}
    onConfirm={onDisable}
    title={I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.disable_popup.title')}
    confirmLabel={I18n.t('publisher.action.yes')}
    cancelLabel={I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.disable_popup.cancel')}
  >
    {I18n.t('publisher.organization_settings.user_provisioning.scim_configuration.disable_popup.body')}
  </SimplePopup>
)
